<template>
<div>
    <base-header v-once  :pageName="`${custNm} 고객님 상담일지`" :popup="true"></base-header>

        <section id="wrap" class="consult-log-container">
            <dt>어떤 서비스(활동) 상담을 하셨나요? <span>필수 입력 (택1)</span></dt>
            <dd class="flex-left">
                <span class="radioBtn"  v-for="(item, index) in ansList" :key="index">
                    <input type="radio" name="ansCode" :id="item.cd" :value="item.cdVl3" v-model="selectedAns">
                    <label :for="item.cd" v-html="item.cdVl1"></label>
                </span>
            </dd>
            <ul>
                <li v-for="(item, index) in ansList" :key="index">{{ item.cdVl2 }}</li>
                <li>홈클래스 수업, 무료 AS수업의 경우 상담 활동 미인정<br>
                    &lt;상담 리포트 발송 금지&gt;</li>
            </ul>
            <dt>상담 하신 상품을 선택해 주세요. <span>필수 입력 (최대 2개)</span></dt>
            <dd class="grid">
                <span class="checkBtn" v-for="(item, index) in anpList" :key="index">
                    <input type="checkbox" name="anpCode" :id="item.cd" :value="item" v-model="selectedAnp" @click="checkLimit($event)">
                    <label :for="item.cd" v-html="item.cdVl1"></label>
                </span>
            </dd>
            <!-- 2026.09.18 챗봇 버튼-->
            <div class="fltMn">
                <button type="button" class="chatbot allow-click"></button>
            </div>
            <!--// 2026.09.18 챗봇 버튼-->

        </section>
        <div class="btnWrap">
            <button type="button" @click="CounselView" class="red">상담리포트 미리보기</button>
        </div>
</div>
</template>

<script>
export default {
  data() {
      return{
          kwkkey: "",
          custDiv: "",
          custNm: "",
          ansList: [],
          anpList: [],
          selectedAnp: [],    // 💡anpList 에 선택된 체크박스 값(cd)이 담길 배열
          selectedAns: '',    // 선택된 서비스 코드 (단일)
          loginGbn : this.$store.getters.loginGbn //로그인구분
      };
  },
  methods: {
      CounselView: function (){ // 가구화 정보 팝업
// 1️⃣ 유효성 검사: 서비스 선택 확인
        if (!this.selectedAns) {
            alert("어떤 서비스 상담을 하셨는지 선택해 주세요.");
            return;
        }

        // 2️⃣ 유효성 검사: 상품 선택 확인 (최소 1개 이상)
        if (this.selectedAnp.length === 0) {
            alert("상담 하신 상품을 하나 이상 선택해 주세요.");
            return;
        }

        // 3️⃣ 데이터 묶기 (다음 페이지로 넘길 정보)
        var parent = {
            name: 'counselView-pop-param',
            data: {
                kwkkey: this.kwkkey,
                custDiv: this.custDiv,
                custNm : this.custNm,
                ansCode: this.selectedAns, // 선택된 서비스 코드
                anpCodes: this.selectedAnp // 선택된 상품 코드 배열
            }
        };
        this.$store.commit("SET_UI_PARENT", parent);

        this.$router.push('/myCstmr/myCstmrView/CounselView');
    },checkLimit(event) {
        // 💡 현재 2개가 이미 선택되어 있고, 새로 체크(checked)하려고 하는 경우
        if (this.selectedAnp.length >= 2 && event.target.checked) {
            //alert("최대 2개까지만 선택 가능합니다.");
            event.preventDefault(); // 💡 체크가 되는 동작 자체를 취소함
        }
    },
    chatbot: function(){
        this.$api.chatbot
        .getChatbotToken()
        .then((token) => {
          this.token = token;
          if(this.token != null){
              // this.$utils.nativeIf.outbound.outlink("https://kyowon-chatbot.ax.dalpha.so/#token="+this.token); //달파 토큰 전송
              window.location.href =  `https://kyowon-chatbot.ax.dalpha.so/#token=${encodeURIComponent(token)}&inpath=WAPLE`;
          }else {
              console.log("else token");
          }
        })
        .catch(function (error) {
          alert(error.rtMsg);
        });
    },
  },
  mounted: function() { //  인스턴스가 마운트 된 직후
    var parent = this.$store.getters.parent;
    // 💡 1. 처음 진입했을 때('popCounsel-pop-param')와
    //    다음 페이지에서 뒤로가기로 돌아왔을 때('counselView-pop-param')를 모두 처리합니다.
    if(parent.name === 'popCounsel-pop-param' || parent.name === 'counselView-pop-param') {
        console.log("현재 parent.data 상태: ", parent.data);

        // 공통 데이터 바인딩
        this.kwkkey = parent.data.kwkkey;
        this.custDiv = parent.data.custDiv;
        this.custNm = parent.data.custNm;

        // 💡 2. 뒤로가기로 돌아온 경우, 사용자가 이전에 선택했던 값을 복구합니다.
        if (parent.name === 'counselView-pop-param') {
            this.selectedAns = parent.data.ansCode || '';
            // 객체 배열인 경우 참조값이 달라져 체크박스가 안 켜질 수 있으므로 아래 API 호출 후 처리하는 것이 더 안전할 수도 있습니다.
            this.selectedAnp = parent.data.anpCodes || [];
        }
        var that = this;
       // var params = {kwkkey:this.kwkkey,custDiv:this.custDiv};

        this.$api.counsel.counselCodeList()
            .then(function(res) {
                that.anpList = res.anpList;
                that.ansList = res.ansList;
            })
            .catch(function(error) {
                alert(error.rtMsg);
            });
        }
  }
};
</script>
